import React from 'react';
import withStyles from '@mui/styles/withStyles';
import Tooltip from '@mui/material/Tooltip';
import TrashIcon from '../icon/TrashIcon';
import { joinDefined } from '../../utils/strings';
import Button from './Button';

const UserCircle = ({ member, useTag = true, onDelete, tiny = true }) => {
    const personName = member && joinDefined([member.FirstName, member.Surname], ' ');

    const content = !!useTag ? (
        <Button
            size={tiny && 'tiny'}
            variant="tag"
            onClick={onDelete ? () => onDelete() : undefined}
        >{personName}</Button>
    ) : (
        <span className="user-circle">
            <span className="abbreviation">{GetInitials(member)}</span>
            {onDelete && (
                <span
                    className="delete"
                    onClick={() => onDelete()}
                    onKeyDown={() => onDelete()}
                    role="button"
                    tabIndex="0"
                >
                    <TrashIcon />
                </span>
            )}
        </span>
    );

    if (onDelete) {
        return <Tooltip title={`Remove ${personName}`}>{content}</Tooltip>;
    }

    return <Tooltip title={`${personName}`}>{content}</Tooltip>;
};

export const GetInitials = user => {
    return firstLetter(user.FirstName) + firstLetter(user.Surname);
};

const firstLetter = str => {
    if (!str) return '';

    str = str.trim();

    if (str.length === 0) return '';

    return str[0].toUpperCase();
};

export default withStyles({})(UserCircle);
